import React from "react";
import { hasPreviewMaskedEurRows } from "../utils/previewMode";

function normalizeCurrencyCode(currencyCode) {
  const code = String(currencyCode || "").trim().toUpperCase();
  return code || "EUR";
}

export default function PreviewTableNotice({
  isPreviewMode = false,
  totalRows = 0,
  language = "de",
  currencyCode = "EUR",
  className = "",
}) {
  if (!hasPreviewMaskedEurRows(totalRows, isPreviewMode)) return null;

  const isEnglish = language === "en";
  const cc = normalizeCurrencyCode(currencyCode);

  const lead = isEnglish ? "Preview mode" : "Vorschau-Modus";
  const body = isEnglish
    ? `Selected calculated examples are visible. Unlock to view all ${cc} values, yearly totals and exports.`
    : `Ausgewählte berechnete Beispiele sind sichtbar. Freischalten für alle ${cc}-Werte, Jahres-Summen und Exporte.`;

  const pill = isEnglish ? "Limited preview" : "Begrenzte Vorschau";

  return (
    <div
      className={[
        "mx-6 mt-3 overflow-hidden rounded-xl border border-indigo-100/60 bg-white/80",
        "shadow-[0_1px_0_rgba(255,255,255,0.95),0_8px_22px_rgba(30,58,138,0.03)]",
        "ring-1 ring-white/80 backdrop-blur-sm",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      role="status"
    >
      <div className="relative">
        <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(90deg,rgba(238,242,255,0.58),rgba(255,255,255,0.94)_40%,rgba(239,246,255,0.42))]" />
        <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-indigo-200/60 to-transparent" />

        <div className="relative flex items-center justify-between gap-3 px-4 py-2">
          <p className="min-w-0 text-[11px] leading-relaxed text-slate-500">
            <span className="font-semibold text-slate-700">{lead}</span>
            <span className="mx-1.5 text-slate-300">·</span>
            <span>{body}</span>
          </p>

          <span className="hidden shrink-0 rounded-full border border-slate-200/80 bg-white/80 px-2.5 py-1 text-[10px] font-medium text-slate-600 shadow-sm sm:inline-flex">
            {pill}
          </span>
        </div>
      </div>
    </div>
  );
}
